// extracted by mini-css-extract-plugin
module.exports = {"header":"userFav_header__3qKjD","tableWrapper":"userFav_tableWrapper__12q1b"};